import { createApp } from 'vue'
import App from './App.vue'

// vue router
import router from './router/index.js'

// vuex
import store from './store'

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import './modules/utilities/linkClickListener';

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        themes: {
            defaultTheme: 'light',
            light: {
                colors: {
                    primary: '#0168b7',
                    "on-primary": '#ffffff',
                    secondary: '#545f70',
                    "on-secondary": '#ffffff',
                    tertiary: '#6c5677',
                    "on-tertiary": '#ffffff',
                    error: '#ba1a1a',
                    "on-error": '#ffffff',
                    background: '#fafaff',
                    "on-background": '#1a1c1e',
                    outline: '#73777f',
                    surface: '#fafaff',
                    "on-surface": '#1a1c1e',
                    "surface-variant": '#dfe2eb',
                    "on-surface-variant": '#43474e',
                    mat: '#f3f3f3',
                    "primary-container": '#d3e4ff',
                    "on-primary-container": '#001c38',
                    "secondary-container": '#d8e3f8',
                    "on-secondary-container": '#111c2b',
                    "tertiary-container": '#f5d9ff',
                    "on-tertiary-container": '#261430',
                    "error-container": '#ffdad6',
                    "on-error-container": '#410002',
                }
            }
        }
    }
})

createApp(App)
.use(router)
.use(vuetify)
.use(store)
.mount('#app')